import { getSupabase, unwrap } from "./supabaseClient";

export interface InterventionFeedback {
  id: number;
  intervention_id: string;
  message: string;
  created_at: string;
  acknowledged_at: string | null;
  acknowledged_by: string | null;
}

/** RLS restricts comments to the relevant respondent or authorized admins. */
export async function fetchInterventionFeedback(interventionId: string): Promise<InterventionFeedback[]> {
  return unwrap(
    await getSupabase()
      .from("intervention_feedback")
      .select("id, intervention_id, message, created_at, acknowledged_at, acknowledged_by")
      .eq("intervention_id", interventionId)
      .order("created_at", { ascending: false })
      .order("id", { ascending: false }),
  ) as InterventionFeedback[];
}

/** Read only pending markers; never expose message text in the list query. */
export async function fetchPendingFeedbackCounts(): Promise<Record<string, number>> {
  const rows = unwrap(
    await getSupabase()
      .from("intervention_feedback")
      .select("intervention_id")
      .is("acknowledged_at", null),
  ) as { intervention_id: string }[];
  const counts: Record<string, number> = {};
  for (const row of rows) counts[row.intervention_id] = (counts[row.intervention_id] ?? 0) + 1;
  return counts;
}

export async function returnToDraftWithFeedback(
  interventionId: string,
  message: string,
): Promise<void> {
  unwrap(
    await getSupabase().rpc("return_intervention_to_draft", {
      p_intervention_id: interventionId,
      p_message: message.trim() || null,
    }),
  );
}

export async function acknowledgeFeedback(id: number): Promise<void> {
  unwrap(
    await getSupabase().rpc("acknowledge_intervention_feedback", { p_feedback_id: id }),
  );
}
